module.exports = __webpack_public_path__ + "02_short_black.18a2af5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_short_black.png
// module id = VpGy
// module chunks = 0